import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Service from "../../services/AlatTransportasiService";
import {message} from "antd";

export const initialState = {
    loading: false,
    dataAlatTransportasi: [],
    dataAlatTransportasiyID:[],
    showMessage:false,
    message:''
}


export const getDataAlatTransportasi = createAsyncThunk('ref/alat_transportasi',async (data, { rejectWithValue }) => {
    try {
        const response = await Service.getDataAll(data)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataAlatTransportasiByID = createAsyncThunk('ref/alat_transportasibyid',async (data, { rejectWithValue }) => {
    const {token,id,id_jadwal}=data;
    try {
        const response = await Service.getDataByID(token,id,id_jadwal)
        //console.log(JSON.stringify(response))
        return response.data;
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const alatTransportasiSlice = createSlice({
    name: 'alat_transportasi',
    initialState,
    reducers: {
        showDataSuccess: (state, action) => {
            state.loading = false
            state.dataAlatTransportasi = action.payload
        },
        showLoading: (state) => {
            state.loading = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataAlatTransportasi.fulfilled, (state, action) => {
                state.loading = false
                state.dataAlatTransportasi = action.payload
            })
            .addCase(getDataAlatTransportasi.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataAlatTransportasi.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataAlatTransportasi = action.payload
            })
            .addCase(getDataAlatTransportasiByID.fulfilled, (state, action) => {
                state.loading = false
                state.dataAlatTransportasiByID = action.payload
            })
            .addCase(getDataAlatTransportasiByID.pending, (state) => {
                state.loading = true
            })
            .addCase(getDataAlatTransportasiByID.rejected, (state, action) => {
                state.message = action.payload
                state.showMessage = true
                state.loading = false
                state.dataAlatTransportasiByID = action.payload
            })
    },
})

export const {
    showDataSuccess,
    showLoading
} = alatTransportasiSlice.actions

export default alatTransportasiSlice.reducer
